import { PropsWithChildren } from 'react';
import { Button, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { UnstyledFieldset } from '../../CompanyProfiles/Scenarios/components/commonStyledComponents';
import { editButton, editOverlay, sectionTitle } from './CommonConfig';

interface IEditSectionOverlayProps extends PropsWithChildren {
  title: string;
  onEdit: () => void;
}

export function EditSectionOverlay({ children, onEdit, title }: IEditSectionOverlayProps) {
  return (
    <div css={editOverlay}>
      <Typography variant='body2' css={sectionTitle}>
        {title}
      </Typography>
      <UnstyledFieldset disabled>{children}</UnstyledFieldset>
      <Button
        variant='contained'
        color='secondary'
        size='large'
        startIcon={<EditOutlinedIcon />}
        css={editButton}
        onClick={onEdit}
        className='edit-display-button'
      >
        Edit
      </Button>
    </div>
  );
}
